import React, { useState } from 'react';
import { Clock, PartyPopper, UsersRound, Vote } from "lucide-react";
import dashboard from "../../../resources/dashboard";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";
import { Button, Radio } from "antd";
import dayjs, { Dayjs } from 'dayjs';
import { Poll, Vote as IVote } from "../../../domains/models/poll";
import "../../../styles/component/dashboard/dashboard-cards.scss"

interface IPollVoteCardView {
    data: any;
    isLoading: boolean;
    navigateToPollsVote: () => void;
    submitResponse: (id: string) => void
}

const PollVoteCardView: React.FC<IPollVoteCardView> = (props) => {

    const resources = dashboard.pollVoteCard;

    const [selectedOptions, setSelectedOptions] = useState<Record<string, string>>({});

    const description = props.data.length > 0 ? `${props.data.length} need your input.` : 'All caught up.';


    const handleOptionSelect = (optionId: string, pollId: string) => {
        setSelectedOptions(prev => ({
            ...prev,
            [pollId]: prev[pollId] === optionId ? "" : optionId,
        }));
    };

    const getTimeDiffInHHmm = (start: Dayjs, end: Dayjs) => {
        const diffInMinutes = end.diff(start, "minute");

        if (diffInMinutes <= 0) {
            return "Time Expired";
        }

        const hours = Math.floor(diffInMinutes / 60);
        const minutes = diffInMinutes % 60;

        return `${hours}h ${minutes}m left`;
    };

    const getDayTimeDifference = (date: string | Date) => {
        //  UTC -> IST
        const targetDate = dayjs.utc(date).tz("Asia/Kolkata");

        // Current time in IST
        const today = dayjs().tz("Asia/Kolkata");

        if (today.isSame(targetDate, "day")) {
            return getTimeDiffInHHmm(today, targetDate);
        }

        const daysLeft = targetDate
            .startOf("day")
            .diff(today.startOf("day"), "day");

        return daysLeft > 0
            ? `${daysLeft} day${daysLeft !== 1 ? "s" : ""} left`
            : "Time Expired";
    };

    const voteVisibility = (data: IVote | Poll) => data.anonymous ? 'Anonymous' : 'Non Anonymous';


    return (
        <div className="dashboard-poll-vote-card dashboard-card" onClick={props.navigateToPollsVote}>
            <div className={'dashboard-card__header'}>
                <span className={'dashboard-card__icon-wrapper dashboard-poll-vote-card__icon-wrapper'}>
                       <Vote className={'dashboard-card__icon dashboard-poll-vote-card__icon'}/>
                </span>

                <h5 className={'dashboard-card__title'}>
                    {resources.title}
                    <p className={'dashboard-card__description'}>
                        {description}
                    </p>
                </h5>
                <span className={'dashboard-poll-vote-card__count'}>

                </span>


            </div>
            <LoadingSkeleton loading={props.isLoading}>
                {props.data.length > 0 ? (
                    <div className={'dashboard-poll-vote-card__container'} onClick={(e) => e.stopPropagation()}>
                        {props.data.map((item: IVote | Poll) => (
                            <div className={'dashboard-poll-vote-card__poll'}>
                                <div className={'dashboard-poll-vote-card__tags-wrapper'}>
                                    <span className={'dashboard-poll-vote-card__tag deadline'}>
                                        <Clock className={'clock-icon'}/>
                                        {getDayTimeDifference(item.endTime)}
                                    </span>
                                    <span
                                        className={'dashboard-poll-vote-card__tag vote-type'}>
                                            {voteVisibility(item)}</span>
                                </div>
                                <div className={'dashboard-poll-vote-card__poll-details'}>
                                    <h5 className={'title'}>{item.title}</h5>
                                    <div
                                        className={'description'}
                                        dangerouslySetInnerHTML={{__html: item.description}}/>

                                    <Radio.Group
                                        className={'dashboard-poll-vote-card__poll-options'}
                                        value={selectedOptions[item.id]}>
                                        {item.options.map((opt: any) => (
                                            <Radio
                                                key={opt.id}
                                                value={opt.id}
                                                onClick={() =>
                                                    handleOptionSelect(opt.id, item.id)}
                                            >
                                                {opt.text}
                                            </Radio>
                                        ))}
                                    </Radio.Group>
                                    <div className={'dashboard-poll-vote-card__action'}>
                                    <span className={'dashboard-poll-vote-card__tag voter-count'}>
                                        <UsersRound
                                            className={'users-icon'}/> {item.totalVotes} responded</span>
                                        <Button
                                            disabled={!selectedOptions[item.id]}
                                            type={'primary'}
                                            onClick={() => props.submitResponse(selectedOptions[item.id])}>
                                            {resources.okButton}
                                        </Button>
                                    </div>
                                </div>
                            </div>


                        ))}
                    </div>
                ) : (
                    <div className={'empty-card'}>
                        <div className={'empty-card__icon-wrapper'}>
                            <PartyPopper className={'empty-card__icon'}/>
                        </div>
                        <div className={'empty-card__content'}>
                            <h5 className={'empty-card__title'}>{resources.emptyCardTitle}</h5>
                            <p className={'empty-card__description'}>{resources.emptyCardContent}</p>
                        </div>
                        <Button type={'link'}>{resources.emptyCardButton}</Button>
                    </div>
                )}
            </LoadingSkeleton>
        </div>
    )
}

export default PollVoteCardView;
